import type {
  HomePolicySummarySource,
  HomePurchaseSource,
} from './homePurchaseStatus';

// Separate from homePurchaseStatus.ts so the confirmation page <meta>, which
// ships in every CMS page's client bundle, does not pull in the hashing
// libraries. Strapi uid the checkout persisted first - BE's policy-summary
// carries none.
export const homePurchaseItemId = (
  purchase: Pick<HomePurchaseSource, 'productUid'> | undefined,
  summary: Pick<HomePolicySummarySource, 'productCode'> | undefined,
): string => purchase?.productUid ?? summary?.productCode ?? '';
